export enum AIUnitWorkspaceColumns {
  Workspace = 'workspace',
  Namespace = 'namespace',
  Pod = 'pod',
  Username = 'username',
  AIUnit = 'aiunit',
}

export type AIUnitWorkspace = {
  workspace: string;
  namespace: string;
  pod: string;
  username: string;
  aiunit: number;
};
